var render, staticRenderFns
import script from "./LayoutVertical.vue?vue&type=script&lang=js"
export * from "./LayoutVertical.vue?vue&type=script&lang=js"
import style0 from "./LayoutVertical.vue?vue&type=style&index=0&id=6ca80a25&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports